import {
  format,
  parseISO,
  startOfDay,
  startOfISOWeek,
  startOfMonth,
} from "date-fns";
import { PlanningEvent } from "../models/planning-event.model";
import { PlanningGroupBy } from "../models/planning-cell.model";

export function bucketKey(date: Date, groupBy: PlanningGroupBy): string {
  if (groupBy === "day") return format(startOfDay(date), "yyyy-MM-dd");
  if (groupBy === "week") return format(startOfISOWeek(date), "yyyy-'W'II");
  return format(startOfMonth(date), "yyyy-MM");
}

/**
 * Un event peut apparaître dans 2 cellules si datePrevu ≠ dateReel.
 * Utilise l'heure locale (date-fns v2 utilise TZ locale par défaut).
 */
export function cellKeysFor<P = unknown>(
  event: PlanningEvent<P>,
  groupBy: PlanningGroupBy = "day",
): string[] {
  const keys = new Set<string>();
  if (event.datePrevu) keys.add(bucketKey(parseISO(event.datePrevu), groupBy));
  if (event.dateReel) keys.add(bucketKey(parseISO(event.dateReel), groupBy));
  return [...keys];
}
